import * as $$ from "jquery-selector-cache";

/**
 * Initialize the module
 */
export function initBtnSharePopin() {
    // Exit when component don't exist
    if (!$$(".share-block").length) {
        return;
    }

    // Exit when component don't exist
    if (!$$(".popin-share-content").length) {
        return;
    }

    $$(".share-block").on("click.toggleLink", (evt: JQuery.ClickEvent) => {
        const currentTarget = $(evt.currentTarget);

        $$("body").addClass("body-no-scroll");
        if ($$("body").hasClass("bp-xl") || $$("body").hasClass("bp-lg")) {
            $$("body").removeClass("body-no-scroll");
        }
        currentTarget.addClass("active");
        $$(".btn-close-popin").removeClass("fade-out-animate").addClass("fade-out-up-animate").next().removeClass("fade-out-animate").addClass("fade-in-animate");
        $$(".popin-share-content").removeClass("d-none").children(".overlay-popin").removeClass("fade-out-animate").addClass("fade-in-animate");
    });
}